<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-toolbar class="primary">
      </v-toolbar>
      <v-list
        nav
      >
        <v-list-item
          dark
          class="primary"
          @click="onNuevoCliente"
        >
          <v-list-item-icon>
            <v-icon>mdi-keyboard-f1</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Nuevo cliente</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
          </v-list-item-icon>
          <v-list-item-title>Filtros</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-filter-variant</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
          </v-list-item-icon>
          <v-list-item-title>Clientes vigentes</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-table-large</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item
          v-if="$can('cuentas.recalcular_todo')"
          @click="onResetearSaldos"
        >
          <v-list-item-icon>
          </v-list-item-icon>
          <v-list-item-title>Resetear Saldos</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-refresh</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <!--
        <v-list-item>
          <v-list-item-icon>
          </v-list-item-icon>
          <v-list-item-title>Clientes inactivos</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-table-large</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
          </v-list-item-icon>
          <v-list-item-title>Exportaciones</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-export</v-icon>
          </v-list-item-icon>
        </v-list-item>
        -->
      </v-list>
    </v-navigation-drawer>

    <!-- CREATE -->
    <clientes-create
      v-model="dialogCreate"
      @created="onCuentaCreated"
    >
    </clientes-create>
    <!--
      * menu buscar / menu cambiar
      * razon social
      * menu usuario
    -->

    <!-- FILTROS -->
    <clientes-filters />
    <!-- 
      * Fecha desde
      * Fecha hasta
      * Kilos
      * Formas de pago
      * Productos
     -->
    <!-- CLIENTES -->
    <clientes-datatable
      @update:selected="onSelect"
    >
    </clientes-datatable>
    <!-- EXPORTACIONES -->
    <!-- <clientes-exportaciones /> -->
    <clientes-listener />
    <clientes-form v-model="dialogForm"/>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ClientesFilters from '@/pages/clientes/FiltersComponent'
import ClientesDatatable from '@/pages/clientes/DatatableComponent'
import ClientesCreate from '@/pages/clientes/CreateComponent'
import ClientesListener from '@/pages/clientes/ListenerComponent'
// import ClientesExports from '@/pages/clientes/ExportsComponent'
import ClientesForm from '@/pages/clientes/FormComponent'

export default {
  name: 'ClientesMainComponent',
  components: {
    'clientes-filters': ClientesFilters,
    'clientes-datatable': ClientesDatatable,
    'clientes-create': ClientesCreate,
    'clientes-listener': ClientesListener,
    // 'clientes-exportaciones': ClientesExports,
    'clientes-form': ClientesForm,
  },
  data () {
    return {
      valid: true,
      attrs: {
        // class: 'mb-6',
        // height: '500px',
        boilerplate: true,
        elevation: 2,
      },
      dialogCreate: false,
      dialogForm: false,
      drawer: true,
    }
  },
  created () {
    window.addEventListener('keydown', this.handleKeyboard);
    this.$root.$on('update:appbarnav', this.onUpdateAppNavBar);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyboard);
    this.$root.$off('update:appbarnav', this.onUpdateAppNavBar);
  },
  computed: {
    //
  },
  watch: {
    //
  },
  methods: {
    ...mapActions('Clientes', ['onFetch']),
    onNuevoCliente (event) {
      event.preventDefault()
      this.dialogCreate = true
    },
    onSelect () {
      this.dialogForm = true
    },
    handleKeyboard(event) {
      const actions = {
        F1: this.onNuevoCliente,
      };
      if (!event.ctrlKey && actions[event.key]) {
        event.preventDefault()
        actions[event.key].call(this, event);
      }
    },
    onCuentaCreated () {
      this.onFetch()
    },
    onUpdateAppNavBar () {
      this.drawer = !this.drawer
    },
    onResetearSaldos(event) {
      event.preventDefault()
      this.$store.dispatch('RecalcularSaldo/onSave', null);
    }
  },
}
</script>
